import React, { Component } from "react";
import { Alert, Button, Table, Spinner } from "react-bootstrap";

class LDDBlock extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: {
                winx64: false,
                winx86: false,
                macos: false,
                macos_arm64: false,
                macos_universal: false,
            }
        }
        this.onClickLddDownload = this.onClickLddDownload.bind(this);
    }

    onClickLddDownload(e, system) {
        this.setState({
            isLoading: {
                ...this.state.isLoading,
                [system]: true
            }
        })
        this.props.onClickLddDownload(e).then((res) => {
            this.setState({
                isLoading: {
                    ...this.state.isLoading,
                    [system]: false
                }
            })
        }).catch(() => {
            this.setState({
                isLoading: {
                    ...this.state.isLoading,
                    [system]: false
                }
            })
        })
    }

    render() {
        return (
            <Alert style={{ width: '100%', cursor: 'pointer', }} variant="light">
                <div onClick={this.props.blockLDDIsOpen ? this.props.closeBlockLDD : this.props.openBlockLDD}
                    style={{ display: "flex", borderBottom: this.props.blockLDDIsOpen ? "1px solid #e3e3e3" : null, height: this.props.blockLDDIsOpen ? "40px" : null /*cursor: "pointer"*/ }}>
                    <div style={{ width: "55%" }}>
                        <div style={{ color: "black" }}>  LWO Digital Defense Client </div>

                    </div>
                    <div style={{ width: "45%" }}>
                        <b style={{ color: "black", float: "right" }}>
                            {this.props.blockLDDIsOpen ?
                                <div >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" fill="none"><path d="M12.25.438H1.75a.881.881 0 00-.875.875v.875c0 .492.383.874.875.874h10.5a.881.881 0 00.875-.874v-.876a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg>
                                </div> :
                                <div><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none"><path d="M12.25 5.438H8.312V1.5a.9.9 0 00-.874-.875h-.875a.881.881 0 00-.875.875v3.938H1.75a.881.881 0 00-.875.875v.875c0 .492.383.875.875.875h3.938V12c0 .492.382.875.875.875h.875A.881.881 0 008.313 12V8.062h3.937a.881.881 0 00.875-.874v-.875a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg></div>
                            }
                        </b>
                    </div>

                </div>
                {
                    this.props.blockLDDIsOpen ? <div>
                        <Alert style={{ width: '100%', cursor: 'pointer', padding: "0.75rem 0", margin: "0" }} variant="light">
                            <div onClick={this.props.blockLDDWinIsOpen ? this.props.closeBlockLDDWin : this.props.openBlockLDDWin}
                                style={{ display: "flex", height: this.props.blockLDDWinIsOpen ? "40px" : null /*cursor: "pointer"*/ }}>
                                <div style={{ width: "55%" }}>
                                    <div style={{ color: "black" }}>Windows</div>
                                </div>
                                <div style={{ width: "45%" }}>
                                    <b style={{ color: "black", float: "right" }}>
                                        {this.props.blockLDDWinIsOpen ?
                                            <div >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" fill="none"><path d="M12.25.438H1.75a.881.881 0 00-.875.875v.875c0 .492.383.874.875.874h10.5a.881.881 0 00.875-.874v-.876a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg>
                                            </div> :
                                            <div><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none"><path d="M12.25 5.438H8.312V1.5a.9.9 0 00-.874-.875h-.875a.881.881 0 00-.875.875v3.938H1.75a.881.881 0 00-.875.875v.875c0 .492.383.875.875.875h3.938V12c0 .492.382.875.875.875h.875A.881.881 0 008.313 12V8.062h3.937a.881.881 0 00.875-.874v-.875a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg></div>
                                        }
                                    </b>
                                </div>

                            </div>

                            {
                                this.props.blockLDDWinIsOpen ? <div>
                                    <Table striped style={{ animation: "fadeIn 1s" }}  >
                                        <tbody>
                                            <tr>
                                                <td> LDD Client 1.3.5 x64.exe</td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="LWO Digital Defense Client 1.3.5 x64.exe"
                                                        value="win"
                                                        disabled={this.state.isLoading.winx64}
                                                        onClick={e => this.onClickLddDownload(e, 'winx64')}>
                                                        {!this.state.isLoading.winx64 ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>LDD Client 1.3.5 x86.exe</td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="LWO Digital Defense Client 1.3.5 x86.exe"
                                                        value="win"
                                                        disabled={this.state.isLoading.winx86}
                                                        onClick={e => this.onClickLddDownload(e, 'winx86')}>
                                                        {!this.state.isLoading.winx86 ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div> : null
                            }
                        </Alert>
                        <div style={{ borderBottom: !this.props.blockLDDWinIsOpen ? "1px solid #e3e3e3" : null }} />
                        <Alert style={{ width: '100%', cursor: 'pointer', padding: "0.75rem 0", margin: "0" }} variant="light">
                            <div onClick={this.props.blockLDDMacIsOpen ? this.props.closeBlockLDDMac : this.props.openBlockLDDMac}
                                style={{ display: "flex", height: this.props.blockLDDMacIsOpen ? "40px" : null /*cursor: "pointer"*/ }}>
                                <div style={{ width: "55%" }}>
                                    <div style={{ color: "black" }}>  MacOS </div>
                                </div>
                                <div style={{ width: "45%" }}>
                                    <b style={{ color: "black", float: "right" }}>
                                        {this.props.blockLDDMacIsOpen ?
                                            <div >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" fill="none"><path d="M12.25.438H1.75a.881.881 0 00-.875.875v.875c0 .492.383.874.875.874h10.5a.881.881 0 00.875-.874v-.876a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg>
                                            </div> :
                                            <div><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none"><path d="M12.25 5.438H8.312V1.5a.9.9 0 00-.874-.875h-.875a.881.881 0 00-.875.875v3.938H1.75a.881.881 0 00-.875.875v.875c0 .492.383.875.875.875h3.938V12c0 .492.382.875.875.875h.875A.881.881 0 008.313 12V8.062h3.937a.881.881 0 00.875-.874v-.875a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg></div>
                                        }
                                    </b>
                                </div>
                            </div>
                            {
                                this.props.blockLDDMacIsOpen ? <div>

                                    <Table striped style={{ animation: "fadeIn 1s" }}  >

                                        <tbody>
                                            <tr>
                                                <td>LDD Client 1.3.1.dmg</td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="LWO Digital Defense Client-1.3.1.dmg"
                                                        value="macos"
                                                        disabled={this.state.isLoading.macos}
                                                        onClick={e => this.onClickLddDownload(e, 'macos')}>
                                                        {!this.state.isLoading.macos ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td> LDD Client 1.3.1-arm64.dmg</td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="LWO Digital Defense Client-1.3.1-arm64.dmg"
                                                        value="macos"
                                                        disabled={this.state.isLoading.macos_arm64}
                                                        onClick={e => this.onClickLddDownload(e, 'macos_arm64')}>
                                                        {!this.state.isLoading.macos_arm64 ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td> LDD Client 1.3.1-universal.dmg</td>
                                                <td className="down-block">
                                                    <Button
                                                        className="down-btn"
                                                        name="LWO Digital Defense Client-1.3.1-universal.dmg"
                                                        value="macos"
                                                        disabled={this.state.isLoading.macos_universal}
                                                        onClick={e => this.onClickLddDownload(e, 'macos_universal')}>
                                                        {!this.state.isLoading.macos_universal ? "скачать"
                                                            :
                                                            <Spinner
                                                                style={{ width: "1rem", height: "1rem" }}
                                                                animation="border"
                                                                variant="light"
                                                            />
                                                        }
                                                    </Button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div> : null
                            }
                        </Alert>
                        <div className="doc-for-ldd">
                            <div
                                onClick={this.props.onClickLddDocDownload}
                            >
                                документация к LDD Client
                            </div>
                        </div>
                    </div> : null
                }

            </Alert>
        );
    }
}

export default LDDBlock;
